/**
 * Единый источник фактов о проекте: используется в метаданных, JSON-LD, sitemap,
 * llms.txt и MCP-инструментах, чтобы цифры не расходились между слоями.
 */

import { getPathname } from "@/i18n/navigation";

export const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL ?? "https://so-origin-pattaya.com";

/**
 * Абсолютный канонический URL страницы для локали. localePrefix у роутинга — 'as-needed',
 * поэтому дефолтная локаль (en) живёт на "/" без префикса, а не на "/en" — прямая
 * конкатенация `${SITE_URL}/${locale}` для en давала бы URL, который 307-редиректит
 * на "/", и это ломало canonical/hreflang/sitemap/JSON-LD (Google должен видеть
 * финальный URL, а не редирект).
 */
export function localizedUrl(locale: string): string {
  const pathname = getPathname({ locale, href: "/" });
  return pathname === "/" ? SITE_URL : `${SITE_URL}${pathname}`;
}

export const PROJECT = {
  name: "So Origin Pattaya",
  developer: "Origin Property",
  /** Продавец и владелец сайта. */
  seller: {
    legalName: "TH Residence Co., Ltd.",
    phone: "+66 97 906 09 99",
    email: "info@thai-residence.com",
    address: {
      street: "453/216 Moo 12",
      locality: "Pattaya City",
      region: "Bang Lamung District, Chon Buri",
      postalCode: "20150",
      country: "TH",
    },
  },
  location: {
    area: "Na Kluea, Pattaya",
    road: "Sukhumvit Road",
    /**
     * Координаты участка на Сукхумвите (Sukhumvit Pattaya 41/3, На Клуа, индекс 20150).
     * Прежняя точка 12.9564 / 100.8878 стояла у пляжа Вонгамат в двух с лишним
     * километрах отсюда и противоречила и адресу, и таблице расстояний на странице.
     */
    lat: 12.9414329,
    lon: 100.9047153,
    /**
     * CID (десятичный) карточки места "So Origin Pattaya" в Google Maps — из
     * hex-идентификатора в фичи-ссылке (0x31220ac75738aadb). Ссылка вида
     * google.com/maps?cid=... ведёт на саму карточку места с названием и
     * фото, а не на пин по голым координатам.
     */
    googleCid: "3540404108344732379",
  },
  units: 790,
  buildings: 3,
  floors: 8,
  landAreaSqm: 10192,
  unitTypes: ["Studio 24 m²", "1 Bedroom 26 m²", "1 Bedroom Plus 34 m²"],
  priceFromTHB: 1_840_000,
  ownership: "freehold",
  completion: "2027-12-31",
  completionLabel: "Q4 2027",
} as const;

/**
 * Дата последнего значимого обновления контента для sitemap. Меняется РУКАМИ при
 * реальных правках: если подставлять new Date(), Google видит «менялось каждый
 * деплой» и перестаёт доверять lastmod, а это единственный атрибут sitemap,
 * который он реально учитывает.
 */
export const CONTENT_LAST_MODIFIED = "2026-08-05";
